import { Component, OnInit } from '@angular/core';
import { ProductosService } from '../../services/productos.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-catalogo',
  templateUrl: './catalogo.component.html',
  styleUrls: ['./catalogo.component.scss']
})
export class CatalogoComponent implements OnInit {

  rango = '0';
  filterProducto = '';
  lista: any = [];
  listaTemp: any = [];
  filtrada: any = [];

  constructor(private productoSvc: ProductosService,
              private router: Router) { }

  ngOnInit(): void {
    this.loadStorage();
    if (this.productoSvc.termino) {
        this.filterProducto = this.productoSvc.termino;
      }
  }

  loadStorage(){
    if (localStorage.getItem('dataProdTorreonmarket')) {
      this.lista = JSON.parse( localStorage.getItem('dataProdTorreonmarket'));
      this.listaTemp = JSON.parse( localStorage.getItem('dataProdTorreonmarket'));
    }
  }

  openProduct(producto: string){
    this.router.navigate([`/producto/${producto}`]);
  }

  value(event: any){
    this.rango = event;
    this.filtrada = [];    
    for (const key in this.listaTemp) {
      if (this.listaTemp[key].precio <= this.rango) {
       this.filtrada.push(this.listaTemp[key]) ;    
      }     
     }
    
  }

  findPrice(){   
    this.lista = this.filtrada;    
  }

}
